import { z } from 'zod'
import { CustomerSchema } from './CustomerSchema'
import { StaffSchema } from './StaffSchema'

export const QrCustomerResponse = z.object({
  existing_customer_id: z.string().nullable(),
  customer: CustomerSchema.partial().nullable(),
})

export const QrStaffResponse = z.object({
  staff: StaffSchema,
})

export const QrDynamicResponse = z.object({
  staff: StaffSchema.optional(),
  existing_customer_id: z.string().nullable(),
  customer: CustomerSchema.optional(),
})
